import { useEffect, useRef, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/personel';
const token = () => localStorage.getItem('token');
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

async function apiFetch(url: string, opts?: RequestInit): Promise<any> {
  try {
    const r = await fetch(url, opts);
    if (!r.ok) {
      const err = await r.json().catch(() => ({ detail: `Sunucu hatası (${r.status})` }));
      throw new Error(err.detail || `Hata: ${r.status}`);
    }
    return await r.json();
  } catch (e: any) {
    if (e instanceof TypeError) throw new Error('Sunucuya bağlanılamadı. Backend çalışıyor mu?');
    throw e;
  }
}

const TUR_ETIKET: Record<string, { label: string; renk: string; arkaplan: string }> = {
  kadrolu:    { label: '657 Kadrolu',   renk: '#1e40af', arkaplan: '#dbeafe' },
  sozlesmeli: { label: '399 KHK Söz.',  renk: '#065f46', arkaplan: '#d1fae5' },
  isci:       { label: '4857 İşçi',     renk: '#92400e', arkaplan: '#fef3c7' },
};
const DURUM_RENK: Record<string, string> = {
  aktif: '#065f46', izinli: '#92400e', gorevde_disi: '#6b21a8',
  emekli: '#374151', ayrildi: '#991b1b',
};
const DURUM_ETIKET: Record<string, string> = {
  aktif: 'Aktif', izinli: 'İzinli', gorevde_disi: 'Görevde Dışı',
  emekli: 'Emekli', ayrildi: 'Ayrıldı',
};
const HIZ_SINIFI: Record<string, string> = {
  'GİH': 'Genel İdare H.', 'TH': 'Teknik H.', 'SH': 'Sağlık H.',
  'AH': 'Avukatlık H.', 'EH': 'Eğitim H.', 'DH': 'Din H.', 'KİT': 'KİT (399)',
};
const EG_ETIKET: Record<string, string> = {
  ilkokul: 'İlkokul', ortaokul: 'Ortaokul', lise: 'Lise',
  onlisans: 'Önlisans', lisans: 'Lisans', yuksek_lisans: 'Yüksek Lisans', doktora: 'Doktora',
};

const BOŞ: Record<string, any> = {
  sicil_no: '', tc_kimlik_no: '', ad: '', soyad: '',
  personel_turu: 'kadrolu', calisma_yeri: 'merkez', isletme_id: '',
  unvan_id: '', birim_adi: '', org_birim_id: '',
  derece: '', kademe: '', hizmet_sinifi: '',
  cetvel: '', sozlesme_no: '', sozlesme_tarihi: '',
  isci_tipi: '', is_kolu_kodu: '', tis_grubu: '',
  durum: 'aktif', goreve_baslama: '', ise_giris_tarihi: '',
  dogum_tarihi: '', dogum_yeri: '', cinsiyet: '', medeni_hal: '',
  egitim_durumu: '', brans: '', telefon: '', email: '', adres: '',
  sgk_no: '', askerlik_durum: '', notlar: '',
};

export default function PersonelSicil() {
  const [liste, setListe] = useState<any[]>([]);
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState<any>(null);
  const [hata, setHata] = useState<string>('');
  const [istatistik, setIstatistik] = useState<any>({});
  const [unvanlar, setUnvanlar] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [orgBirimler, setOrgBirimler] = useState<any[]>([]);
  const [filtre, setFiltre] = useState({ personel_turu: '', calisma_yeri: '', durum: '', arama: '', org_birim_id: '' });
  const [daireler, setDaireler] = useState<any[]>([]);
  const [toast, setToast] = useState<string>('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [excelSonuc, setExcelSonuc] = useState<any>(null);
  const [excelYukleniyor, setExcelYukleniyor] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [kullaniciModal, setKullaniciModal] = useState(false);
  const [kullaniciForm, setKullaniciForm] = useState<any>({});
  const [kullaniciHata, setKullaniciHata] = useState('');
  const [roller, setRoller] = useState<any[]>([]);

  const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  useEffect(() => {
    yukle();
    fetch(`${API}/istatistik`, { headers: hdr() }).then(r => r.json()).then(setIstatistik);
    fetch(`${API}/unvanlar`, { headers: hdr() }).then(r => r.json()).then(setUnvanlar);
    fetch(`${BASE}/api/isletmeler`, { headers: hdr() }).then(r => r.json()).then(d => setIsletmeler(Array.isArray(d) ? d : d.isletmeler || []));
    fetch(`${BASE}/api/org/birimler-listesi`, { headers: hdr() }).then(r => r.json()).then(d => {
      const liste = Array.isArray(d) ? d : [];
      setOrgBirimler(liste);
      setDaireler(liste.filter((b: any) => b.tur === 'daire'));
    });
    fetch(`${BASE}/api/tanimlar/roller`, { headers: hdr() }).then(r => r.json()).then(setRoller).catch(() => {});
  }, []);

  function yukle(f = filtre) {
    setYukleniyor(true);
    const params = new URLSearchParams();
    if (f.personel_turu)  params.set('personel_turu', f.personel_turu);
    if (f.calisma_yeri)   params.set('calisma_yeri', f.calisma_yeri);
    if (f.durum)          params.set('durum', f.durum);
    if (f.arama)          params.set('arama', f.arama);
    if (f.org_birim_id)   params.set('org_birim_id', f.org_birim_id);
    fetch(`${API}/?${params}`, { headers: hdr() })
      .then(r => r.json()).then(setListe).finally(() => setYukleniyor(false));
  }

  function filtreDegistir(k: string, v: string) {
    const yeni = { ...filtre, [k]: v };
    setFiltre(yeni);
    yukle(yeni);
  }

  function kullaniciOlusturAc(p: any) {
    const isletmeRol = p.calisma_yeri === 'isletme' ? 'isletme_personel' : 'gm_personel';
    setKullaniciForm({
      personel_id: p.id,
      ad_soyad: `${p.ad} ${p.soyad}`,
      email: p.email || '',
      kullanici_adi: '',
      sifre: '',
      rol: isletmeRol,
      isletme_id: p.isletme_id || '',
      birim_adi: p.birim_adi || '',
    });
    setKullaniciHata('');
    setKullaniciModal(true);
  }

  async function kullaniciKaydet() {
    if (!kullaniciForm.kullanici_adi?.trim()) { setKullaniciHata('Kullanıcı adı zorunludur'); return; }
    if (!kullaniciForm.sifre || kullaniciForm.sifre.length < 6) { setKullaniciHata('Şifre en az 6 karakter olmalı'); return; }
    if (!kullaniciForm.rol) { setKullaniciHata('Rol seçimi zorunludur'); return; }
    const isletmeRol = ['isletme_mudur', 'isletme_personel'].includes(kullaniciForm.rol);
    if (isletmeRol && !kullaniciForm.isletme_id) { setKullaniciHata('Bu rol için işletme seçimi zorunludur'); return; }
    try {
      const body: any = {
        kullanici_adi: kullaniciForm.kullanici_adi,
        ad_soyad: kullaniciForm.ad_soyad,
        email: kullaniciForm.email || undefined,
        sifre: kullaniciForm.sifre,
        rol: kullaniciForm.rol,
        personel_id: kullaniciForm.personel_id,
      };
      if (isletmeRol) body.isletme_id = Number(kullaniciForm.isletme_id);
      else body.birim_adi = kullaniciForm.birim_adi || undefined;
      await apiFetch(`${BASE}/api/kullanicilar/`, { method: 'POST', headers: hdr(), body: JSON.stringify(body) });
      setKullaniciModal(false);
      setToast(`${kullaniciForm.ad_soyad} için kullanıcı oluşturuldu`);
      setTimeout(() => setToast(''), 3000);
    } catch (e: any) { setKullaniciHata(e.message); }
  }

  async function pasifTopluSil() {
    const pasifSayisi = liste.filter(p => ['emekli', 'ayrildi'].includes(p.durum)).length;
    if (pasifSayisi === 0) { alert('Listede pasif (emekli/ayrıldı) personel bulunmuyor.'); return; }
    if (!window.confirm(`Durumu "Emekli" veya "Ayrıldı" olan ${pasifSayisi} personel ve tüm alt kayıtları kalıcı olarak silinecek.\n\nBu işlem GERİ ALINAMAZ!\n\nDevam etmek istiyor musunuz?`)) return;
    try {
      const r = await apiFetch(`${API}/pasif/toplu-sil`, { method: 'DELETE', headers: hdr() });
      setToast(`${r.silinen} pasif personel kalıcı olarak silindi`);
      setTimeout(() => setToast(''), 4000);
      setSecili(null);
      yukle();
      apiFetch(`${API}/istatistik`, { headers: hdr() }).then(setIstatistik).catch(() => {});
    } catch (e: any) {
      alert('Hata: ' + e.message);
    }
  }

  async function silPersonel(id: number, ad: string) {
    if (!window.confirm(`"${ad}" adlı personeli silmek istediğinizden emin misiniz?\nBu işlem geri alınamaz.`)) return;
    try {
      await apiFetch(`${API}/${id}`, { method: 'DELETE', headers: hdr() });
      setSecili(null);
      yukle();
      apiFetch(`${API}/istatistik`, { headers: hdr() }).then(setIstatistik).catch(() => {});
    } catch (e: any) {
      alert('Silme hatası: ' + e.message);
    }
  }

  async function kaydet() {
    if (!form.sicil_no?.trim()) { setHata('Sicil numarası zorunludur.'); return; }
    if (!form.ad?.trim() || !form.soyad?.trim()) { setHata('Ad ve soyad zorunludur.'); return; }
    if (form.tc_kimlik_no && form.tc_kimlik_no.length !== 11) { setHata('TC kimlik numarası 11 haneli olmalıdır.'); return; }
    setHata('');
    const method = form.id ? 'PUT' : 'POST';
    const url = form.id ? `${API}/${form.id}` : `${API}/`;
    const temiz = { ...form };
    ['isletme_id', 'unvan_id', 'derece', 'kademe', 'org_birim_id'].forEach(k => {
      if (temiz[k] === '' || temiz[k] === null) temiz[k] = null;
      else temiz[k] = Number(temiz[k]) || null;
    });
    try {
      await apiFetch(url, { method, headers: hdr(), body: JSON.stringify(temiz) });
      setForm(null);
      yukle();
      apiFetch(`${API}/istatistik`, { headers: hdr() }).then(setIstatistik).catch(() => {});
      const mesaj = form.id ? `${form.ad} ${form.soyad} güncellendi.` : `${form.ad} ${form.soyad} kaydedildi.`;
      setToast(mesaj);
      setTimeout(() => setToast(''), 3000);
    } catch (e: any) {
      setHata(e.message);
    }
  }

  async function personelSec(p: any) {
    const detay = await fetch(`${API}/${p.id}`, { headers: hdr() }).then(r => r.json());
    setSecili(detay);
  }

  function sablonIndir() {
    fetch(`${API}/excel-sablon`, { headers: hdr() })
      .then(r => r.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = 'personel_sablon.xlsx'; a.click();
        URL.revokeObjectURL(url);
      });
  }

  async function excelYukle(e: React.ChangeEvent<HTMLInputElement>) {
    const dosya = e.target.files?.[0];
    if (!dosya) return;
    if (fileInputRef.current) fileInputRef.current.value = '';
    setExcelYukleniyor(true);
    const form = new FormData();
    form.append('dosya', dosya);
    try {
      const r = await fetch(`${API}/excel-yukle`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token()}` },
        body: form,
      });
      const sonuc = await r.json();
      if (!r.ok) throw new Error(sonuc.detail || 'Yükleme hatası');
      setExcelSonuc(sonuc);
      yukle();
      apiFetch(`${API}/istatistik`, { headers: hdr() }).then(setIstatistik).catch(() => {});
    } catch (err: any) {
      setExcelSonuc({ hata_mesaj: err.message });
    } finally {
      setExcelYukleniyor(false);
    }
  }

  const filtreliUnvanlar = unvanlar.filter(u => !form || u.personel_turu === form.personel_turu);

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      {toast && (
        <div style={{
          position: 'fixed', bottom: 28, right: 28, zIndex: 9999,
          background: '#166534', color: '#fff', borderRadius: 8,
          padding: '12px 20px', fontSize: 14, fontWeight: 500,
          boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
          display: 'flex', alignItems: 'center', gap: 10,
        }}>
          ✔ {toast}
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>Personel Sicili</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
            657 · 399 KHK · 4857 İş K. — Merkez & İşletmeler
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={sablonIndir} title="Doldurulacak Excel şablonunu indir" style={{
            background: '#fff', color: '#166534', border: '1.5px solid #166534', borderRadius: 8,
            padding: '9px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13,
          }}>⬇ Şablon İndir</button>

          <label title="Excel dosyası yükle (şablona uygun .xlsx)" style={{
            background: excelYukleniyor ? '#6b7280' : '#059669', color: '#fff', borderRadius: 8,
            padding: '9px 16px', cursor: excelYukleniyor ? 'not-allowed' : 'pointer',
            fontWeight: 600, fontSize: 13, display: 'inline-block',
          }}>
            {excelYukleniyor ? 'Yükleniyor...' : '⬆ Excel Yükle'}
            <input ref={fileInputRef} type="file" accept=".xlsx,.xls"
              onChange={excelYukle} disabled={excelYukleniyor}
              style={{ display: 'none' }} />
          </label>

          <button onClick={() => { setForm({ ...BOŞ }); setHata(''); }} style={{
            background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
            padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
          }}>+ Yeni Personel</button>
        </div>
      </div>

      {/* İSTATİSTİK KARTLARI */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 12, marginBottom: 20 }}>
        {[
          { label: 'Toplam', value: istatistik.toplam, renk: '#1d4ed8', bg: '#eff6ff' },
          { label: 'Aktif', value: istatistik.aktif, renk: '#065f46', bg: '#ecfdf5' },
          { label: 'Kadrolu', value: istatistik.kadrolu, renk: '#1e40af', bg: '#dbeafe' },
          { label: 'Sözleşmeli', value: istatistik.sozlesmeli, renk: '#065f46', bg: '#d1fae5' },
          { label: 'İşçi', value: istatistik.isci, renk: '#92400e', bg: '#fef3c7' },
          { label: 'Merkez', value: istatistik.merkez, renk: '#6b21a8', bg: '#f5f3ff' },
          { label: 'İşletme', value: istatistik.isletme_sayi, renk: '#b45309', bg: '#fffbeb' },
        ].map(k => (
          <div key={k.label} style={{ background: k.bg, borderRadius: 10, padding: '12px 16px', textAlign: 'center' }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: k.renk }}>{k.value ?? '—'}</div>
            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* FİLTRELER */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <input value={filtre.arama} onChange={e => filtreDegistir('arama', e.target.value)}
          placeholder="Ad, soyad, sicil no..." style={inputSt} />
        <select value={filtre.personel_turu} onChange={e => filtreDegistir('personel_turu', e.target.value)} style={selectSt}>
          <option value="">Tüm Türler</option>
          <option value="kadrolu">657 Kadrolu</option>
          <option value="sozlesmeli">399 KHK Sözleşmeli</option>
          <option value="isci">4857 İşçi</option>
        </select>
        <select value={filtre.calisma_yeri} onChange={e => filtreDegistir('calisma_yeri', e.target.value)} style={selectSt}>
          <option value="">Merkez & İşletme</option>
          <option value="merkez">Merkez</option>
          <option value="isletme">İşletme</option>
        </select>
        <select value={filtre.durum} onChange={e => filtreDegistir('durum', e.target.value)} style={selectSt}>
          <option value="">Tüm Durumlar</option>
          {Object.entries(DURUM_ETIKET).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        {daireler.length > 0 && (
          <select value={filtre.org_birim_id} onChange={e => filtreDegistir('org_birim_id', e.target.value)} style={selectSt}>
            <option value="">Tüm Daire Başkanlıkları</option>
            {daireler.map((d: any) => <option key={d.id} value={d.id}>{d.ad}</option>)}
          </select>
        )}
        <button onClick={pasifTopluSil}
          style={{ background: '#fff0f0', color: '#991b1b', border: '1px solid #fca5a5', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap' }}>
          🗑 Pasif Olanları Sil
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: secili ? '1fr 380px' : '1fr', gap: 16 }}>
        {/* LİSTE */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          {yukleniyor ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Yükleniyor…</div>
          ) : liste.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Personel bulunamadı.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                  {['Sicil No', 'Ad Soyad', 'Tür', 'Unvan', 'Birim / İşletme', 'Derece/Kademe', 'Durum', ''].map(h => (
                    <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 12 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {liste.map((p, i) => {
                  const tur = TUR_ETIKET[p.personel_turu] || { label: p.personel_turu, renk: '#374151', arkaplan: '#f3f4f6' };
                  return (
                    <tr key={p.id} onClick={() => personelSec(p)}
                      style={{ borderBottom: '1px solid #f3f4f6', cursor: 'pointer',
                        background: secili?.id === p.id ? '#eff6ff' : i % 2 === 0 ? '#fff' : '#fafafa',
                      }}>
                      <td style={{ padding: '9px 14px', fontWeight: 600, color: '#1d4ed8', fontFamily: 'monospace' }}>{p.sicil_no}</td>
                      <td style={{ padding: '9px 14px', fontWeight: 600 }}>{p.ad} {p.soyad}</td>
                      <td style={{ padding: '9px 14px' }}>
                        <span style={{ background: tur.arkaplan, color: tur.renk, borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>
                          {tur.label}
                        </span>
                      </td>
                      <td style={{ padding: '9px 14px', color: '#374151' }}>{p.unvan_adi || '—'}</td>
                      <td style={{ padding: '9px 14px', color: '#6b7280', fontSize: 12 }}>
                        {p.calisma_yeri === 'merkez' ? 'Merkez' : `İşletme #${p.isletme_id}`}
                        {p.birim_adi ? ` · ${p.birim_adi}` : ''}
                      </td>
                      <td style={{ padding: '9px 14px', color: '#374151', fontFamily: 'monospace', fontSize: 12 }}>
                        {p.derece ? `${p.derece}/${p.kademe || '—'}` : '—'}
                      </td>
                      <td style={{ padding: '9px 14px' }}>
                        <span style={{ color: DURUM_RENK[p.durum] || '#374151', fontWeight: 600, fontSize: 12 }}>
                          {DURUM_ETIKET[p.durum] || p.durum}
                        </span>
                      </td>
                      <td style={{ padding: '9px 14px' }}>
                        <button onClick={e => { e.stopPropagation(); setForm({ ...p }); }} style={{
                          background: 'none', border: '1px solid #d1d5db', borderRadius: 6,
                          padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: '#374151', marginRight: 4,
                        }}>Düzenle</button>
                        <button onClick={e => { e.stopPropagation(); silPersonel(p.id, `${p.ad} ${p.soyad}`); }} style={{
                          background: 'none', border: '1px solid #fca5a5', borderRadius: 6,
                          padding: '3px 10px', cursor: 'pointer', fontSize: 12, color: '#dc2626',
                        }}>Sil</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* DETAY KARTI */}
        {secili && (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'auto', maxHeight: '80vh' }}>
            <div style={{ background: '#1d4ed8', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>{secili.ad} {secili.soyad}</div>
                <div style={{ color: '#bfdbfe', fontSize: 12 }}>{secili.sicil_no} · {secili.unvan_adi}</div>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => kullaniciOlusturAc(secili)} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>👤 Kullanıcı Oluştur</button>
                <button onClick={() => setSecili(null)} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', borderRadius: 6, padding: '4px 10px', cursor: 'pointer' }}>✕</button>
              </div>
            </div>
            <div style={{ padding: 16 }}>
              {/* Rozetler */}
              <div style={{ display: 'flex', gap: 6, marginBottom: 14, flexWrap: 'wrap' }}>
                <span style={{ ...rozetSt, background: TUR_ETIKET[secili.personel_turu]?.arkaplan, color: TUR_ETIKET[secili.personel_turu]?.renk }}>
                  {TUR_ETIKET[secili.personel_turu]?.label}
                </span>
                <span style={{ ...rozetSt, background: '#f3f4f6', color: '#374151' }}>
                  {secili.calisma_yeri === 'merkez' ? '🏢 Merkez' : '🌾 İşletme'}
                </span>
                <span style={{ ...rozetSt, background: '#f3f4f6', color: DURUM_RENK[secili.durum] }}>
                  {DURUM_ETIKET[secili.durum]}
                </span>
              </div>

              <KartBolum baslik="İstihdam Bilgileri">
                <SatirBilgi etiket="Birim" deger={secili.birim_adi} />
                {secili.personel_turu === 'kadrolu' && <>
                  <SatirBilgi etiket="Hizmet Sınıfı" deger={HIZ_SINIFI[secili.hizmet_sinifi] || secili.hizmet_sinifi} />
                  <SatirBilgi etiket="Derece/Kademe" deger={secili.derece ? `${secili.derece}. Derece / ${secili.kademe}. Kademe` : null} />
                </>}
                {secili.personel_turu === 'sozlesmeli' && <>
                  <SatirBilgi etiket="Cetvel" deger={secili.cetvel ? `${secili.cetvel}. Cetvel (399 KHK)` : null} />
                  <SatirBilgi etiket="Sözleşme No" deger={secili.sozlesme_no} />
                  <SatirBilgi etiket="Sözleşme Tarihi" deger={secili.sozlesme_tarihi} />
                </>}
                {secili.personel_turu === 'isci' && <>
                  <SatirBilgi etiket="İşçi Tipi" deger={secili.isci_tipi} />
                  <SatirBilgi etiket="İş Kolu Kodu" deger={secili.is_kolu_kodu} />
                  <SatirBilgi etiket="TİS Grubu" deger={secili.tis_grubu} />
                </>}
                <SatirBilgi etiket="Göreve Başlama" deger={secili.goreve_baslama} />
                <SatirBilgi etiket="İşe Giriş" deger={secili.ise_giris_tarihi} />
                <SatirBilgi etiket="SGK No" deger={secili.sgk_no} />
              </KartBolum>

              <KartBolum baslik="Kişisel Bilgiler">
                <SatirBilgi etiket="Doğum Tarihi" deger={secili.dogum_tarihi} />
                <SatirBilgi etiket="Doğum Yeri" deger={secili.dogum_yeri} />
                <SatirBilgi etiket="Cinsiyet" deger={secili.cinsiyet === 'E' ? 'Erkek' : secili.cinsiyet === 'K' ? 'Kadın' : null} />
                <SatirBilgi etiket="Medeni Hal" deger={secili.medeni_hal} />
                <SatirBilgi etiket="Öğrenim" deger={EG_ETIKET[secili.egitim_durumu] || secili.egitim_durumu} />
                <SatirBilgi etiket="Branş" deger={secili.brans} />
                <SatirBilgi etiket="Askerlik" deger={secili.askerlik_durum} />
              </KartBolum>

              <KartBolum baslik="İletişim">
                <SatirBilgi etiket="Telefon" deger={secili.telefon} />
                <SatirBilgi etiket="E-posta" deger={secili.email} />
                <SatirBilgi etiket="Adres" deger={secili.adres} />
              </KartBolum>

              {/* Son atamalar */}
              {secili.atamalar?.length > 0 && (
                <KartBolum baslik="Son Atamalar">
                  {secili.atamalar.slice(0, 3).map((a: any) => (
                    <div key={a.id} style={{ fontSize: 12, borderLeft: '3px solid #1d4ed8', paddingLeft: 8, marginBottom: 8 }}>
                      <div style={{ fontWeight: 600, color: '#1d4ed8' }}>{a.atama_turu.replace(/_/g, ' ')}</div>
                      <div style={{ color: '#374151' }}>{a.yeni_birim || '—'} · {a.atama_tarihi}</div>
                    </div>
                  ))}
                </KartBolum>
              )}

              {/* Son performans */}
              {secili.performanslar?.length > 0 && (
                <KartBolum baslik="Son Performans">
                  {secili.performanslar.slice(0, 1).map((pf: any) => (
                    <div key={pf.id}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: 12, color: '#374151' }}>{pf.yil} Yılı</span>
                        <span style={{ fontWeight: 700, fontSize: 18, color: pf.toplam_puan >= 90 ? '#065f46' : pf.toplam_puan >= 75 ? '#1d4ed8' : pf.toplam_puan >= 60 ? '#92400e' : '#991b1b' }}>
                          {pf.toplam_puan?.toFixed(1)}
                        </span>
                      </div>
                      <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>{pf.sonuc?.replace(/_/g, ' ')}</div>
                    </div>
                  ))}
                </KartBolum>
              )}

              {secili.notlar && (
                <div style={{ background: '#fffbeb', borderRadius: 8, padding: 10, fontSize: 12, color: '#92400e', marginTop: 8 }}>
                  📌 {secili.notlar}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* FORM MODALI */}
      {form && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 720, maxHeight: '90vh', overflow: 'auto' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 18, fontWeight: 700 }}>{form.id ? 'Personel Güncelle' : 'Yeni Personel Ekle'}</h3>
            {hata && (
              <div style={{ background: '#fee2e2', border: '1px solid #fecaca', borderRadius: 8, padding: '10px 14px', marginBottom: 14, color: '#991b1b', fontSize: 13, fontWeight: 600 }}>
                ⚠️ {hata}
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Alan etiket="Sicil No *" gerekli><input value={form.sicil_no} onChange={e => setForm({ ...form, sicil_no: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="TC Kimlik No"><input value={form.tc_kimlik_no} onChange={e => setForm({ ...form, tc_kimlik_no: e.target.value })} style={inputSt} maxLength={11} /></Alan>
              <Alan etiket="Ad *" gerekli><input value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Soyad *" gerekli><input value={form.soyad} onChange={e => setForm({ ...form, soyad: e.target.value })} style={inputSt} /></Alan>

              <Alan etiket="Personel Türü *" gerekli>
                <select value={form.personel_turu} onChange={e => setForm({ ...form, personel_turu: e.target.value, unvan_id: '' })} style={selectSt}>
                  <option value="kadrolu">657 Kadrolu</option>
                  <option value="sozlesmeli">399 KHK Sözleşmeli</option>
                  <option value="isci">4857 İşçi</option>
                </select>
              </Alan>
              <Alan etiket="Çalışma Yeri">
                <select value={form.calisma_yeri} onChange={e => setForm({ ...form, calisma_yeri: e.target.value })} style={selectSt}>
                  <option value="merkez">Merkez</option>
                  <option value="isletme">İşletme</option>
                </select>
              </Alan>

              {form.calisma_yeri === 'isletme' && (
                <Alan etiket="İşletme">
                  <select value={form.isletme_id} onChange={e => setForm({ ...form, isletme_id: e.target.value })} style={selectSt}>
                    <option value="">Seçiniz</option>
                    {isletmeler.map((i: any) => <option key={i.id} value={i.id}>{i.ad}</option>)}
                  </select>
                </Alan>
              )}

              <Alan etiket="Unvan">
                <select value={form.unvan_id} onChange={e => setForm({ ...form, unvan_id: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  {filtreliUnvanlar.map(u => <option key={u.id} value={u.id}>{u.ad}</option>)}
                </select>
              </Alan>
              <Alan etiket="Birim / Daire">
                <select
                  value={form.org_birim_id || ''}
                  onChange={e => {
                    const id = e.target.value;
                    const b = orgBirimler.find((x: any) => String(x.id) === id);
                    setForm({ ...form, org_birim_id: id, birim_adi: b ? b.ad : '' });
                  }}
                  style={selectSt}
                >
                  <option value="">Seçiniz (kurum yapısından)</option>
                  {/* Üst yönetim / danışma birimleri */}
                  {orgBirimler.filter((b: any) => ['denetim', 'yardimci', 'gm_yardimcisi'].includes(b.tur)).length > 0 && (
                    <optgroup label="── Üst Yönetim / Danışma ──">
                      {orgBirimler
                        .filter((b: any) => ['denetim', 'yardimci', 'gm_yardimcisi'].includes(b.tur))
                        .map((b: any) => <option key={b.id} value={b.id}>{b.kisaltma ? `[${b.kisaltma}] ` : ''}{b.ad}</option>)}
                    </optgroup>
                  )}
                  {/* Daire başkanlıkları → şube müdürlükleri */}
                  {orgBirimler
                    .filter((b: any) => b.tur === 'daire')
                    .sort((a: any, b: any) => a.sira - b.sira)
                    .map((daire: any) => (
                      <optgroup key={daire.id} label={`${daire.kisaltma ? `[${daire.kisaltma}] ` : ''}${daire.ad}`}>
                        <option value={daire.id}>— Daire Başkanlığı</option>
                        {orgBirimler
                          .filter((s: any) => s.parent_id === daire.id && s.tur === 'sube')
                          .sort((a: any, b: any) => a.sira - b.sira)
                          .map((s: any) => <option key={s.id} value={s.id}>{s.ad}</option>)}
                      </optgroup>
                    ))
                  }
                  {/* Tarım işletmeleri */}
                  {orgBirimler.filter((b: any) => b.tur === 'isletme').length > 0 && (
                    <optgroup label="── Tarım İşletmeleri ──">
                      {orgBirimler
                        .filter((b: any) => b.tur === 'isletme')
                        .map((b: any) => <option key={b.id} value={b.id}>{b.ad}{b.il ? ` (${b.il})` : ''}</option>)}
                    </optgroup>
                  )}
                </select>
              </Alan>

              {form.personel_turu === 'kadrolu' && <>
                <Alan etiket="Hizmet Sınıfı">
                  <select value={form.hizmet_sinifi} onChange={e => setForm({ ...form, hizmet_sinifi: e.target.value })} style={selectSt}>
                    <option value="">Seçiniz</option>
                    {Object.entries(HIZ_SINIFI).map(([k, v]) => <option key={k} value={k}>{k} — {v}</option>)}
                  </select>
                </Alan>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Alan etiket="Derece"><input type="number" min={1} max={15} value={form.derece} onChange={e => setForm({ ...form, derece: e.target.value })} style={{ ...inputSt, width: '100%' }} /></Alan>
                  <Alan etiket="Kademe"><input type="number" min={1} max={4} value={form.kademe} onChange={e => setForm({ ...form, kademe: e.target.value })} style={{ ...inputSt, width: '100%' }} /></Alan>
                </div>
              </>}

              {form.personel_turu === 'sozlesmeli' && <>
                <Alan etiket="Cetvel (399 KHK)">
                  <select value={form.cetvel} onChange={e => setForm({ ...form, cetvel: e.target.value })} style={selectSt}>
                    <option value="">Seçiniz</option>
                    <option value="I">I. Cetvel — Yöneticiler</option>
                    <option value="II">II. Cetvel — Diğer</option>
                  </select>
                </Alan>
                <Alan etiket="Sözleşme No"><input value={form.sozlesme_no} onChange={e => setForm({ ...form, sozlesme_no: e.target.value })} style={inputSt} /></Alan>
                <Alan etiket="Sözleşme Tarihi"><input type="date" value={form.sozlesme_tarihi} onChange={e => setForm({ ...form, sozlesme_tarihi: e.target.value })} style={inputSt} /></Alan>
              </>}

              {form.personel_turu === 'isci' && <>
                <Alan etiket="İşçi Tipi">
                  <select value={form.isci_tipi} onChange={e => setForm({ ...form, isci_tipi: e.target.value })} style={selectSt}>
                    <option value="">Seçiniz</option>
                    <option value="daimi">Daimi İşçi</option>
                    <option value="gecici">Geçici İşçi</option>
                  </select>
                </Alan>
                <Alan etiket="SGK İş Kolu Kodu"><input value={form.is_kolu_kodu} onChange={e => setForm({ ...form, is_kolu_kodu: e.target.value })} style={inputSt} /></Alan>
                <Alan etiket="TİS Grubu"><input value={form.tis_grubu} onChange={e => setForm({ ...form, tis_grubu: e.target.value })} style={inputSt} /></Alan>
              </>}

              <Alan etiket="Göreve Başlama"><input type="date" value={form.goreve_baslama} onChange={e => setForm({ ...form, goreve_baslama: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="İşe Giriş Tarihi"><input type="date" value={form.ise_giris_tarihi} onChange={e => setForm({ ...form, ise_giris_tarihi: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Durum">
                <select value={form.durum} onChange={e => setForm({ ...form, durum: e.target.value })} style={selectSt}>
                  {Object.entries(DURUM_ETIKET).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </Alan>
              <Alan etiket="Cinsiyet">
                <select value={form.cinsiyet} onChange={e => setForm({ ...form, cinsiyet: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  <option value="E">Erkek</option>
                  <option value="K">Kadın</option>
                </select>
              </Alan>
              <Alan etiket="Doğum Tarihi"><input type="date" value={form.dogum_tarihi} onChange={e => setForm({ ...form, dogum_tarihi: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Doğum Yeri"><input value={form.dogum_yeri} onChange={e => setForm({ ...form, dogum_yeri: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Medeni Hal">
                <select value={form.medeni_hal} onChange={e => setForm({ ...form, medeni_hal: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  <option value="bekar">Bekar</option>
                  <option value="evli">Evli</option>
                  <option value="bosanmis">Boşanmış</option>
                  <option value="dul">Dul</option>
                </select>
              </Alan>
              <Alan etiket="Öğrenim Durumu">
                <select value={form.egitim_durumu} onChange={e => setForm({ ...form, egitim_durumu: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  {Object.entries(EG_ETIKET).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </Alan>
              <Alan etiket="Branş / Bölüm"><input value={form.brans} onChange={e => setForm({ ...form, brans: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Telefon"><input value={form.telefon} onChange={e => setForm({ ...form, telefon: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="E-posta"><input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="SGK No"><input value={form.sgk_no} onChange={e => setForm({ ...form, sgk_no: e.target.value })} style={inputSt} /></Alan>
              <Alan etiket="Askerlik Durumu"><input value={form.askerlik_durum} onChange={e => setForm({ ...form, askerlik_durum: e.target.value })} style={inputSt} placeholder="Yaptı / Muaf / Tecilli" /></Alan>
            </div>
            <Alan etiket="Adres" tam>
              <textarea value={form.adres} onChange={e => setForm({ ...form, adres: e.target.value })} style={{ ...inputSt, height: 60, resize: 'vertical' }} />
            </Alan>
            <Alan etiket="Notlar" tam>
              <textarea value={form.notlar} onChange={e => setForm({ ...form, notlar: e.target.value })} style={{ ...inputSt, height: 60, resize: 'vertical' }} />
            </Alan>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => { setForm(null); setHata(''); }} style={{ ...btnSt, background: '#f3f4f6', color: '#374151' }}>İptal</button>
              <button onClick={kaydet} style={{ ...btnSt, background: '#1d4ed8', color: '#fff' }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* Excel Yükleme Sonuç Modalı */}
      {excelSonuc && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setExcelSonuc(null)}>
          <div style={{ background: '#fff', borderRadius: 12, width: 520, maxHeight: '80vh', overflowY: 'auto', padding: 28, boxShadow: '0 12px 40px rgba(0,0,0,0.2)' }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 18px', fontSize: 17 }}>Excel Yükleme Sonucu</h3>

            {excelSonuc.hata_mesaj ? (
              <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '12px 16px', color: '#991b1b', fontSize: 14 }}>
                Hata: {excelSonuc.hata_mesaj}
              </div>
            ) : (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 20 }}>
                  {[
                    { label: 'Yeni Eklendi', value: excelSonuc.eklendi, renk: '#166534', bg: '#f0fdf4' },
                    { label: 'Güncellendi', value: excelSonuc.guncellendi, renk: '#92400e', bg: '#fffbeb' },
                    { label: 'Hatalı Satır', value: excelSonuc.hatalar?.length || 0, renk: '#991b1b', bg: '#fef2f2' },
                  ].map(k => (
                    <div key={k.label} style={{ background: k.bg, borderRadius: 8, padding: '14px 16px', textAlign: 'center' }}>
                      <div style={{ fontSize: 26, fontWeight: 700, color: k.renk }}>{k.value}</div>
                      <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>{k.label}</div>
                    </div>
                  ))}
                </div>

                {excelSonuc.hatalar?.length > 0 && (
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#991b1b', marginBottom: 8 }}>Hatalı Satırlar:</div>
                    <div style={{ background: '#fef2f2', borderRadius: 8, padding: 12, maxHeight: 200, overflowY: 'auto' }}>
                      {excelSonuc.hatalar.map((h: any, i: number) => (
                        <div key={i} style={{ fontSize: 12, color: '#7f1d1d', padding: '3px 0', borderBottom: '1px solid #fecaca' }}>
                          <strong>Satır {h.satir}:</strong> {h.hata}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {excelSonuc.toplam_islem === 0 && excelSonuc.hatalar?.length === 0 && (
                  <div style={{ color: '#6b7280', fontSize: 13, textAlign: 'center' }}>İşlenecek veri bulunamadı.</div>
                )}
              </>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setExcelSonuc(null)} style={{ ...btnSt, background: '#1d4ed8', color: '#fff' }}>Tamam</button>
            </div>
          </div>
        </div>
      )}

      {/* KULLANICI OLUŞTUR MODAL */}
      {kullaniciModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 480, maxHeight: '90vh', overflow: 'auto' }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 17, fontWeight: 700 }}>👤 Kullanıcı Oluştur</h3>
            <div style={{ background: '#eff6ff', borderRadius: 8, padding: '8px 12px', marginBottom: 14, fontSize: 13, color: '#1d4ed8' }}>
              Personel: <strong>{kullaniciForm.ad_soyad}</strong>
            </div>
            {kullaniciHata && (
              <div style={{ background: '#fee2e2', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 12px', marginBottom: 12, color: '#991b1b', fontSize: 13 }}>⚠️ {kullaniciHata}</div>
            )}
            <div style={{ display: 'grid', gap: 12 }}>
              <Alan etiket="Kullanıcı Adı *" gerekli>
                <input value={kullaniciForm.kullanici_adi} onChange={e => setKullaniciForm({ ...kullaniciForm, kullanici_adi: e.target.value })} style={inputSt} placeholder="ornek.kullanici" autoFocus />
              </Alan>
              <Alan etiket="Şifre * (min. 6 karakter)" gerekli>
                <input type="password" value={kullaniciForm.sifre} onChange={e => setKullaniciForm({ ...kullaniciForm, sifre: e.target.value })} style={inputSt} />
              </Alan>
              <Alan etiket="E-posta">
                <input value={kullaniciForm.email} onChange={e => setKullaniciForm({ ...kullaniciForm, email: e.target.value })} style={inputSt} />
              </Alan>
              <Alan etiket="Rol *" gerekli>
                <select value={kullaniciForm.rol} onChange={e => {
                  const yeniRol = e.target.value;
                  const isletmeRol = ['isletme_mudur', 'isletme_personel'].includes(yeniRol);
                  setKullaniciForm({ ...kullaniciForm, rol: yeniRol, isletme_id: isletmeRol ? kullaniciForm.isletme_id : '' });
                }} style={selectSt}>
                  {roller.map((r: any) => <option key={r.kod} value={r.kod}>{r.ad}</option>)}
                </select>
              </Alan>
              {['isletme_mudur', 'isletme_personel'].includes(kullaniciForm.rol) ? (
                <Alan etiket="İşletme *" gerekli>
                  <select value={kullaniciForm.isletme_id} onChange={e => setKullaniciForm({ ...kullaniciForm, isletme_id: e.target.value })} style={selectSt}>
                    <option value="">Seçiniz</option>
                    {isletmeler.map((i: any) => <option key={i.id} value={i.id}>{i.ad}</option>)}
                  </select>
                </Alan>
              ) : (
                <Alan etiket="Çalıştığı Birim / Daire">
                  <input value={kullaniciForm.birim_adi} onChange={e => setKullaniciForm({ ...kullaniciForm, birim_adi: e.target.value })} style={inputSt} placeholder="örn: Strateji Geliştirme Dairesi" />
                </Alan>
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
              <button onClick={() => setKullaniciModal(false)} style={{ ...btnSt, background: '#f3f4f6', color: '#374151' }}>İptal</button>
              <button onClick={kullaniciKaydet} style={{ ...btnSt, background: '#1d4ed8', color: '#fff' }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function KartBolum({ baslik, children }: { baslik: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>{baslik}</div>
      <div style={{ background: '#f9fafb', borderRadius: 8, padding: 10 }}>{children}</div>
    </div>
  );
}

function SatirBilgi({ etiket, deger }: { etiket: string; deger?: any }) {
  if (!deger) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '3px 0', borderBottom: '1px solid #f3f4f6' }}>
      <span style={{ color: '#6b7280' }}>{etiket}</span>
      <span style={{ color: '#111827', fontWeight: 500, textAlign: 'right', maxWidth: '60%' }}>{deger}</span>
    </div>
  );
}

function Alan({ etiket, gerekli, tam, children }: { etiket: string; gerekli?: boolean; tam?: boolean; children: React.ReactNode }) {
  return (
    <div style={{ gridColumn: tam ? '1 / -1' : undefined }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
        {etiket}{gerekli && <span style={{ color: '#dc2626' }}> *</span>}
      </label>
      {children}
    </div>
  );
}

const inputSt: React.CSSProperties = {
  width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7,
  fontSize: 13, boxSizing: 'border-box', outline: 'none',
};
const selectSt: React.CSSProperties = { ...inputSt, background: '#fff' };
const btnSt: React.CSSProperties = {
  padding: '9px 20px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14,
};
const rozetSt: React.CSSProperties = {
  fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6,
};
